/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_COMMITTEE } from "../graphql";
import settingConfig from "../config/settings.config.json";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCommitteeMethods extends IPluginMethodMap {
    getCommitteeProps(args: any): Promise<any>;
}

export class GetCommitteeService implements IAgentPlugin {
    readonly methods: IGetCommitteeMethods;

    constructor() {
        this.methods = {
            getCommitteeProps: this.getCommittee.bind(this),
        };
    }

    async getCommittee(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        let filter = {
            limit: 20000,
            skip: 0,
            where: [
                {
                    column: "role",
                    op: "Equal",
                    value: "99403c8b-abc1-4796-b61f-78e0c4022792"
                }
            ]
        };
        try {
            if (client) {
                const res = await client.query({
                    query: GET_COMMITTEE,
                    variables: {
                        input: filter,
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data) {
                    let invitedByArray = this.formatInvitedBy(
                        res?.data?.getUserList?.data
                    );
                    const settings = this.getTransformConfig(settingConfig, invitedByArray)
                    console.log("settings==>", invitedByArray)
                    return {
                        ...settingConfig,
                        settingConfig: settings,
                        committeeReport: res?.data?.getUserList?.data?.map((_item: any) => {
                            let label: any = _item?.email;
                            if (_item?.fullName && _item?.fullName !== " ") {
                                label = _item?.fullName
                            }
                            return { id: _item?.email, label: label };
                        }),
                    };
                }
            }
        } catch (err: any) {
            console.log(`error in table data`, err);
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }
            return settingConfig;
        }
    }

    private getTransformConfig(data: any, invitedByArray?: any) {
        data.tableHeaders[4].filterTypes[1].options = invitedByArray
        return data;
    }

    private formatInvitedBy(data: any) {
        let _rowData: any = [];
        data &&
            data.forEach((item?: any) => {
                if (item?.fullName && item?.fullName !== null && item?.fullName !== '') {
                    _rowData.push(
                        item?.fullName
                    );
                }
            });
        const invitedByArray = Array.from(new Set(_rowData));
        let array: any[] = [];
        invitedByArray && invitedByArray.forEach((item: any) => {
            array.push({
                value: item,
                label: item
            })
        })
        console.log("invitedByArray==>", array);
        return array;
    }
}
